import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const Faq = ({ content }) => {
  const items = content.faq || [];
  if (!items.length) return null;

  return (
    <section id="faq" className="bg-white py-16 sm:py-24" data-testid="faq-section">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <div className="mb-10 text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-terracotta">Domande frequenti</span>
          <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-olive sm:text-3xl lg:text-4xl" data-testid="faq-title">
            Tutto quello che vuoi sapere
          </h2>
        </div>
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {items.map((item, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="rounded-2xl border border-sand bg-cream px-5" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left font-display text-base font-semibold text-olive hover:no-underline sm:text-lg" data-testid={`faq-question-${i}`}>
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-stone-600 sm:text-base" data-testid={`faq-answer-${i}`}>
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
